import type { ChatDialogResponse } from '@/core/generated/api';
import type { ChatDialogData } from '@/entities/ChatDialog/model/types';

/** Объединяет загруженные страницы каналов без пропуска ещё не загруженной части */
export const selectChatInboxPage = (
    sources: ChatDialogData[],
    limit: number,
    pinned: ChatDialogResponse[] = [],
) => {
    const capacity = Math.min(limit, ...sources.filter((source) => source.nextOffset !== null)
        .map((source) => source.dialogs.length));

    const pins = new Map(pinned.map((dialog) => [dialog.id, dialog]));
    const merged = new Map(pinned.map((dialog) => [dialog.id, dialog]));

    sources.flatMap((source) => source.dialogs)
        .forEach((dialog) => {
            merged.set(dialog.id, {
                ...dialog,
                operatorPinnedAt: pins.get(dialog.id)?.operatorPinnedAt ?? null,
            });
        });

    sources.forEach((source) => {
        const selected = source.selectedDialog;

        const current = selected?.id
            ? merged.get(selected.id)
            : undefined;

        const selectedDate = Date.parse(selected?.lastActivityAt ?? '') || 0;
        const currentDate = Date.parse(current?.lastActivityAt ?? '') || 0;

        if (selected?.id && pins.has(selected.id) && selectedDate >= currentDate) {
            merged.set(selected.id, {
                ...selected,
                operatorPinnedAt: pins.get(selected.id)?.operatorPinnedAt,
            });
        }
    });

    const dialogs = [...merged.values()]
        .filter((dialog) => sources[0]?.filter !== 'unread' || (dialog.unreadCount ?? 0) > 0)
        .sort((left, right) => {
            const byPin = Date.parse(right.operatorPinnedAt ?? '') || 0;
            const leftPin = Date.parse(left.operatorPinnedAt ?? '') || 0;

            if (byPin !== leftPin) return byPin - leftPin;

            const byDate = (Date.parse(right.lastActivityAt ?? '') || 0)
                - (Date.parse(left.lastActivityAt ?? '') || 0);

            return Number.isFinite(byDate) && byDate !== 0
                ? byDate
                : (right.id ?? '').localeCompare(left.id ?? '');
        });

    return {
        dialogs: dialogs.slice(0, capacity),
        hasMore: dialogs.length > capacity || sources.some((source) => source.nextOffset !== null),
    };
};
